import validator from 'validator';

const OPTIONS = { ignore_whitespace: true };

const startsWithVowel = (str => !!~'aeiou'.split('').indexOf(str.charAt(0).toLowerCase()));

const validateEmpty = (values, key, name) => {
  let isEmpty = validator.isEmpty(values[key] || '', OPTIONS);

  return isEmpty ? { [key]: `You must provide ${startsWithVowel(name) ? 'an' : 'a'} ${name}` } : {};
};

export const userValidator = (values = {}) => {
  return {
    ...validateEmpty(values, 'last_name', 'last name'),
    ...validateEmpty(values, 'first_name', 'first name'),
    ...validateEmpty(values, 'mobile_number', 'mobile number')
  };
};

export const accountValidator = (values = {}) => {
  return {
    ...validateEmpty(values, 'address_line1', 'address line 1'),
    ...validateEmpty(values, 'address_postcode', 'address postcode'),
    ...validateEmpty(values, 'address_state', 'address state'),
    ...validateEmpty(values, 'address_suburb', 'address suburb'),
    ...validateEmpty(values, 'name', 'account name')
  };
};

